import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=5afb16f6&scoped=true"
import script from "./Manual.vue?vue&type=script&lang=js"
export * from "./Manual.vue?vue&type=script&lang=js"
import style0 from "./Manual.vue?vue&type=style&index=0&id=5afb16f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb16f6",
  null
  
)

export default component.exports